import { Badge } from "../components/ui/badge";
import { Link } from "react-router-dom";
import { ImageWithFallback } from "../components/figma/ImageWithFallback";

export default function PartnersPreview() {
  const partners = [
    {
      name: "Razorpay",
      logo: "/assets/logos/razorpay-logo.png",
      description: "India's leading payment gateway for seamless online transactions."
    },
    {
      name: "Shiprocket",
      logo: "/assets/logos/shiprocket-logo.webp",
      description: "Smart shipping and logistics automation for e-commerce businesses."
    },
    {
      name: "MyOperator",
      logo: "/assets/logos/myoperator-logo.png",
      description: "Cloud-based call management and telephony solutions for businesses."
    },
  ];
  return (
    <section className="py-16 bg-white" aria-labelledby="partners-preview-heading">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <Badge className="mb-4 bg-purple-100 text-purple-800">Our Partners</Badge>
        <h2 id="partners-preview-heading" className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900 mb-2">
          Trusted by Industry Leaders
        </h2>
        <p className="text-gray-600 mb-8">
          We collaborate with top technology providers to deliver seamless business solutions.
        </p>
        <div className="flex flex-wrap justify-center items-center gap-10 mb-8">
          {partners.map((partner) => (
            <div
              key={partner.name}
              className="flex flex-col items-center transition-transform duration-200 hover:scale-105 max-w-xs border border-gray-200 rounded-xl p-6 bg-white shadow-sm"
            >
              <ImageWithFallback
                src={partner.logo}
                alt={partner.name}
                className="w-38 h-auto mb-2"
              />
              <span className="text-xs text-gray-600 font-semibold mb-1">{partner.name}</span>
              <span className="text-xs text-gray-500 text-center">{partner.description}</span>
            </div>
          ))}
        </div>
        <Link
          to="/partners"
          className="inline-block mt-2 px-6 py-2 bg-blue-600 text-white rounded-full font-semibold shadow hover:bg-blue-700 transition"
        >
          See all partners &rarr;
        </Link>
      </div>
    </section>
  );
}